import React, { useContext } from 'react';
import { TelefoniaContext } from '../context';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import '../App.css';

const CardList = () => {
  const {
    searchResults,
    collectionName,
    setShow,
    showModal,
    colaboradores,
    handleClickInsert,
    idToAdd,
    setIdToAdd,
    redirect,
    handleClickDelete,
    showAlert,
    handleClickAlert,
    handleClickButtonAdd,
    addCard
  } = useContext(TelefoniaContext);

  const renderSearchResults = () => {
    if (searchResults !== undefined && searchResults.length > 0) {
      return (searchResults.map((result) => (
        <Card key={result._id} style={{ width: '19rem' }} id={result._id}>
          <Card.Body>
            <Card.Title>{result.nome}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted capitalized">{ collectionName === 'manutencao' ? 'Suporte' : collectionName }</Card.Subtitle>
            <Card.Text>
              <strong>Id da Fila:</strong> {result.idFilaRamal} <br />
              <strong>Ramal: </strong>{result.ramal} <br />
              <strong>Url Do Google Chat:</strong> { result.urlGoogleChat } <br />
              <strong>Id Do Google Chat:</strong> { result.idGoogleChat } <br />
              <strong>Atendimentos: </strong>{ result.atendimentos }
              <br/><span style={ { marginTop: 10 } }>Horário de Trabalho</span>
              { result.horarioTrabalho !== undefined && result.horarioTrabalho.length !== 0 && 
              <ul>
                <li>Segunda-Feira: <br/>
                  Início: { `${ result.horarioTrabalho[1].horaDeInicioTrabalho }:${ result.horarioTrabalho[1].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[1].horaDeInicioIntervalo }:${ result.horarioTrabalho[1].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[1].horaDeFimIntervalo }:${ result.horarioTrabalho[1].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[1].horaDeFimTrabalho }:${ result.horarioTrabalho[1].minutoDeFimTrabalho }` }
                </li>
                <li>Terça-Feira: <br/>
                  Início: { `${ result.horarioTrabalho[2].horaDeInicioTrabalho }:${ result.horarioTrabalho[2].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[2].horaDeInicioIntervalo }:${ result.horarioTrabalho[2].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[2].horaDeFimIntervalo }:${ result.horarioTrabalho[2].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[2].horaDeFimTrabalho }:${ result.horarioTrabalho[2].minutoDeFimTrabalho }` }
                </li>
                <li>Quarta-Feira: <br/>
                  Início: { `${ result.horarioTrabalho[3].horaDeInicioTrabalho }:${ result.horarioTrabalho[3].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[3].horaDeInicioIntervalo }:${ result.horarioTrabalho[3].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[3].horaDeFimIntervalo }:${ result.horarioTrabalho[3].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[3].horaDeFimTrabalho }:${ result.horarioTrabalho[3].minutoDeFimTrabalho }` }
                </li>
                <li>Quinta-Feira: <br/>
                  Início: { `${ result.horarioTrabalho[4].horaDeInicioTrabalho }:${ result.horarioTrabalho[4].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[4].horaDeInicioIntervalo }:${ result.horarioTrabalho[4].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[4].horaDeFimIntervalo }:${ result.horarioTrabalho[4].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[4].horaDeFimTrabalho }:${ result.horarioTrabalho[4].minutoDeFimTrabalho }` }
                </li>
                <li>Sexta-Feira: <br/>
                  Início: { `${ result.horarioTrabalho[5].horaDeInicioTrabalho }:${ result.horarioTrabalho[5].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[5].horaDeInicioIntervalo }:${ result.horarioTrabalho[5].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[5].horaDeFimIntervalo }:${ result.horarioTrabalho[5].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[5].horaDeFimTrabalho }:${ result.horarioTrabalho[5].minutoDeFimTrabalho }` }
                </li>
                <li>Sábado: <br/>
                  Início: { `${ result.horarioTrabalho[6].horaDeInicioTrabalho }:${ result.horarioTrabalho[6].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[6].horaDeInicioIntervalo }:${ result.horarioTrabalho[6].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[6].horaDeFimIntervalo }:${ result.horarioTrabalho[6].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[6].horaDeFimTrabalho }:${ result.horarioTrabalho[6].minutoDeFimTrabalho }` }
                </li>
                <li>Domingo: <br/>
                  Início: { `${ result.horarioTrabalho[0].horaDeInicioTrabalho }:${ result.horarioTrabalho[0].minutoDeInicioTrabalho }` } 
                  <br/>Intervalo:  { `${ result.horarioTrabalho[0].horaDeInicioIntervalo }:${ result.horarioTrabalho[0].minutoDeInicioIntervalo }` }  -  { `${ result.horarioTrabalho[0].horaDeFimIntervalo }:${ result.horarioTrabalho[0].minutoDeFimIntervalo }` }
                  <br/>Fim: { `${ result.horarioTrabalho[0].horaDeFimTrabalho }:${ result.horarioTrabalho[0].minutoDeFimTrabalho }` }
                </li>
              </ul>}
            </Card.Text>
            <Button id={result._id} onClick={ handleClickDelete } variant="danger">Excluir</Button>
            <Card.Link href={`${process.env.REACT_APP_DOMINIO}/edit/${ collectionName }/${result._id}`}><Button variant="info" style={ { marginLeft: 10 } }>Editar</Button></Card.Link>
          </Card.Body>
        </Card>
      )));
    }
  };

  const renderCard = () => (
    <div style={{ width: '15rem' }} >
      <button
        type="button"
        className="button"
        onClick={ handleClickButtonAdd }
      >
        <Image
          style={{ width: 150 }}
          src="data:image/png;base64,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"
        />
      </button>
    </div>
  );
  const renderSelect = () => (
    <Form.Group controlId="validationFormik01">
     <Form.Label>
        Quem você quer adicionar nessa Fila?
        <Form.Control as="select" value={ idToAdd } onChange={({ target }) => setIdToAdd(target.value)}>
          {colaboradores !== undefined && colaboradores.map((e) => (
            <option key={e._id} value={e._id}>{e.nome}</option>
          ))}
        </Form.Control>
      </Form.Label>
    </Form.Group>
  );

  function MyVerticallyCenteredModal(props) {
      return (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Adicionar Usuário na fila
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { renderSelect() }
            <Form.Group>
              <Button
                variant="info"
                onClick={handleClickInsert}
              >
                Adicionar
              </Button>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
  }

  const renderAlert = () => (
    <Modal show={showAlert} style={ { marginTop: 50 } }>
      <Modal.Header closeButton>
        <Modal.Title>Deseja Excluir O Representante da Fila? <span></span> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Button onClick={ handleClickAlert } value="nao" variant="success">Não</Button>
        <Button onClick={ handleClickAlert } value="sim" variant="danger">Sim</Button>
      </Modal.Body>
    </Modal>
  )

  const redirectToPainel = () => window.location.reload();

  return (
    <div>
      { renderSearchResults() }
      { addCard && renderCard()}

      <MyVerticallyCenteredModal
        show={showModal}
        onHide={() => setShow(false)}
      />
      { redirect && redirectToPainel()}
      { showAlert && renderAlert()}

    </div>
  );
}

export default CardList;